import React, { useRef } from 'react'
import { Box, Flex } from '@workwhile/ui'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { GeneralDetails } from './components/GeneralDetails'
import { AssessmentSection } from './components/AssessmentSection'
import { EvaluationPanel } from './components/EvaluationPanel'
import { useAssessmentDetailContextValue } from './context/AssessmentDetailProvider'

const AssessmentDetailHeader = () => {
  const { state, actions } = useAssessmentDetailContextValue()

  return (
    <Header
      title={`${state.workerName} (${state.workerId}) — ${state.positionName}`}
      subTitle="Worker Assessment Detail"
      rightContent={
        <Flex
          alignItems="center"
          gap={2}
          data-context-key="user_id"
          data-context-value={state.workerId}
          data-context-label={state.workerName}
        >
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
        </Flex>
      }
    />
  )
}

export const AssessmentDetailMain = () => {
  const {
    state: { assessmentCalls },
  } = useAssessmentDetailContextValue()
  const audioRefs = useRef<(HTMLAudioElement | null)[]>([])

  const handlePlay = (index: number) => {
    audioRefs.current.forEach((audio, audioIndex) => {
      if (audioIndex !== index && audio) {
        audio.pause()
      }
    })
  }

  return (
    <>
      <AssessmentDetailHeader />
      <Box margin={3}>
        <GeneralDetails />
        <Flex mt={3} gap={3} alignItems="flex-start">
          <Box flex={1} minWidth={0}>
            {assessmentCalls.map((assessment, index) => (
              <Box key={`${assessment.shiftId}-${index}`} mb={3}>
                <AssessmentSection
                  assessment={assessment}
                  audioRef={(element) => {
                    audioRefs.current[index] = element
                  }}
                  onPlay={() => handlePlay(index)}
                />
              </Box>
            ))}
          </Box>
          <Box flex={1} minWidth={0}>
            <EvaluationPanel />
          </Box>
        </Flex>
      </Box>
    </>
  )
}
